import client from "./client";

const eventsApi = {
  list(schoolId, params = {}) {
    return client.get(`/schools/${schoolId}/events`, { params }).then((r) => r.data);
  },

  create(schoolId, data) {
    return client.post(`/schools/${schoolId}/events`, data).then((r) => r.data);
  },

  update(schoolId, id, data) {
    return client.put(`/schools/${schoolId}/events/${id}`, data).then((r) => r.data);
  },

  delete(schoolId, id) {
    return client.delete(`/schools/${schoolId}/events/${id}`).then((r) => r.data);
  },

  getHolidays(schoolId, params = {}) {
    return client.get(`/schools/${schoolId}/events/holidays`, { params }).then((r) => r.data);
  },

  createHoliday(schoolId, data) {
    return client.post(`/schools/${schoolId}/events/holidays`, data).then((r) => r.data);
  },
};

export default eventsApi;
